/**
 * Paths for node content (api/v2/news).
 * - proxy: under our Next.js API (/api-next/nodes and /api-next/nodes/[id])
 * - upstream: external node content API (server-side)
 */
export const nodeContentRoutes = {
  list: { proxy: 'nodes', upstream: 'api/v2/news' },
  story: { proxy: 'nodes', upstream: 'api/v2/news' },
} as const;
